<script lang="ts" setup>
defineProps<{
  text: string
}>()
</script>

<template>
  <div class="text-sm">
    Пример: <i class="pre-wrap text-main-silver">{{ text }}</i>.
  </div>
</template>
